/**
 * Tiny dev-gated logger.
 *
 * Replaces bare `console.warn(...)` calls so we don't leak diagnostic
 * output into production consoles (per Feb 2026 code-review pass).
 * In development we still emit to the console so devs get feedback;
 * in production the calls are no-ops.
 *
 * We deliberately only wrap `warn` / `error`. `info` / `debug` are not
 * exposed — if you catch yourself needing them, promote the message to
 * a warn (or, better, surface it in the UI via toast).
 */
const isProd = process.env.NODE_ENV === "production";

export const log = {
  warn: (...args) => {
    if (!isProd) console.warn(...args);
  },
  error: (...args) => {
    // Errors are worth keeping in production for browser devtools during
    // support debugging — they're already visible in Network / React logs.
    console.error(...args);
  },
};
